import { baseApi } from "../../helpers/baseApi/adminService.baseApi";
import type {
  ILoginRequestResponse,
  IUser,
} from "../../origin/authApi/types";

const extendedApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    loginRequest: build.mutation<
      ILoginRequestResponse,
      { identifier: string; password: string }
    >({
      query: ({ identifier, password }) => ({
        url: "/auth/login",
        method: "POST",
        body: { identifier, password },
      }),
    }),
    getUserRequest: build.query<IUser, { id?: number }>({
      query: () => ({
        url: "/auth/me",
        method: "GET",
      }),
    }),
    magicLinkLoginRequest: build.mutation<
      { email: string },
      { email: string }
    >({
      query: ({ email }) => ({
        url: "/auth/magic-link",
        method: "POST",
        body: { email },
      }),
    }),
    magicLinkLoginSubmit: build.mutation<
      ILoginRequestResponse,
      { token: string }
    >({
      query: ({ token }) => ({
        url: "/auth/magic-link/verify",
        method: "POST",
        body: { token },
      }),
    }),
    resetPasswordRequest: build.mutation<
      { email: string },
      { email: string }
    >({
      query: ({ email }) => ({
        url: "/auth/password/reset-request",
        method: "POST",
        body: { email },
      }),
    }),
    resetPasswordSubmit: build.mutation<
      { message: string },
      { password: string; token: string }
    >({
      query: ({ password, token }) => ({
        url: "/auth/password/reset",
        method: "POST",
        body: { password, token },
      }),
    }),
    changePasswordSubmit: build.mutation<
      { message: string },
      { password: string; oldPassword: string }
    >({
      query: ({ password, oldPassword }) => ({
        url: "/auth/password/change",
        method: "POST",
        body: { password, oldPassword },
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useChangePasswordSubmitMutation,
  useGetUserRequestQuery,
  useLoginRequestMutation,
  useMagicLinkLoginRequestMutation,
  useMagicLinkLoginSubmitMutation,
  useResetPasswordRequestMutation,
  useResetPasswordSubmitMutation,
} = extendedApi;
export const { endpoints } = extendedApi;
